<template>
  <kst-table action input-mode :data="userAddresses">
    <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
      <template #header>
        <kst-header-blank />
      </template>
      <template #default="{ row }">
        <kst-tooltip v-if="row.Errors.length > 0" error-mode>
          <template #content>
            <kst-list :items="row.Errors"/>
          </template>
          <kst-icon error-mode/>
        </kst-tooltip>
      </template>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="kst-vendor-edit-Name"
      field="Name"
      :label="VendorAddressCatalog.Name.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="VendorAddressCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="kst-vendor-edit-Address"
      field="Address"
      :label="VendorAddressCatalog.Address.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="VendorAddressCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="kst-vendor-edit-ContactName"
      field="ContactName"
      :label="VendorAddressCatalog.ContactName.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="VendorAddressCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="kst-vendor-edit-ContactMobile"
      field="ContactMobile"
      :label="VendorAddressCatalog.ContactMobile.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="VendorAddressCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="kst-vendor-edit-ContactPhone"
      field="ContactPhone"
      :label="VendorAddressCatalog.ContactPhone.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="VendorAddressCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="kst-vendor-edit-ContactEmail"
      field="ContactEmail"
      :label="VendorAddressCatalog.ContactEmail.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="VendorAddressCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <template #action="{ index }">
      <kst-tooltip delete-mode hover-only :content="Model.VendorAddress.Module.FullName">
        <kst-button delete-mode is-round @click="handleRowDelete(index)"/>
      </kst-tooltip>
    </template>

    <template #empty-body>
      <ValidationProvider v-slot="{ errors }" name="userAddresses" rules="required">
        <kst-error :array-blank-mode="!!errors"/>
      </ValidationProvider>
    </template>
  </kst-table>
</template>

<script>
import DialogMixin from "@/mixins/DialogMixin.js";
import Info from "../VendorInfo.js";
import Model from "../VendorModel.js";
import VendorAddressCatalog from "../VendorAddressCatalog.js";

export default {
  mixins: [DialogMixin],
  props: {
    userAddresses: Array
  },
  data: () => ({
    Model: Model,
    VendorAddressCatalog: VendorAddressCatalog,
    selectedIndex: null
  }),
  methods: {
    handleRowDelete(index) {
      this.selectedIndex = index;
      this.showConfirm(
        Info.Message.New_ConfirmDeleteAddress,
        this.handleRowDelete_Confirm,
        this.handleRowDelete_Cancel
      );
    },
    handleRowDelete_Confirm() {
      this.userAddresses.splice(this.selectedIndex, 1);

      this.selectedIndex = null;
    },
    handleRowDelete_Cancel() {
      this.selectedIndex = null;
    },
    handleRowErrors(errors, field, index) {
      Model.setAddressErrors(this.userAddresses[index], field, errors);
    }
  }
}
</script>